<template>
<div>
    <div class="row justify-content-center" >
        <div class="col-12" >
            <div class="table-responsive rounded-2" >
                <div v-if="(typeof tournamentAllData.noAcceptedResultsCount === 'undefined')" class="alert alert-primary" role="alert" >Nie ma aktywnego turnieju.</div>
                <template v-else >
                    <div v-if="((typeof tournamentAllData.eliminators === 'undefined') || (tournamentAllData.eliminators.length === 0))" ></div>
                    <!-- <div v-if="((typeof tournamentAllData.eliminators === 'undefined') || (tournamentAllData.eliminators.length === 0))" class="alert alert-primary" role="alert">Nie ma zakwalifikowanych zawodnikiów.</div> -->
                    <template v-else >

                        <table class="table table-sm table-bordered border table-border" >

                            <thead>
                                <tr>
                                    <th rowspan="2" scope="col" class="align-middle text-center table-header-item" style="max-width: 20px;" >Tor</th>
                                    <th rowspan="2" scope="col" class="align-middle text-center table-header-item" style="max-width: 30px;" >Grupa</th>
                                    <th rowspan="2" scope="col" class="align-middle text-center table-header-item" >Zawodnik</th>
                                    <th rowspan="2" scope="col" class="align-middle text-center table-header-item bonus-field-width" >HDCP</th>
                                    <th rowspan="2" scope="col" class="align-middle text-center table-header-item bonus-field-width" >Bonus</th>

                                    <th :colspan="(eliminatorRoundsCount === 3) ? 6 : 4" scope="col" class="align-middle text-center table-header-item table-left-border-big" >Eliminator</th>

                                    <th colspan="3" scope="col" class="align-middle text-center table-header-item table-left-border-big" >Finał</th>
                                </tr>
                                <tr>
                                    <th scope="col" class="align-middle text-center table-header-item table-left-border-big game-field-width" >1 Gra</th> 
                                    <th scope="col" class="align-middle text-center table-header-item result-field-width" >Wynik</th> 

                                    <th scope="col" class="align-middle text-center table-header-item table-left-border-big game-field-width" >2 Gra</th> 
                                    <th scope="col" class="align-middle text-center table-header-item result-field-width" >Wynik</th>
                                    
                                    <template v-if="eliminatorRoundsCount === 3">
                                    <th scope="col" class="align-middle text-center table-header-item table-left-border-big game-field-width" >3 Gra</th> 
                                    <th scope="col" class="align-middle text-center table-header-item result-field-width" >Wynik</th> 
                                    </template>

                                    <th scope="col" class="align-middle text-center table-header-item table-left-border-big text-nowrap game-field-width" >Gra</th> 
                                    <th scope="col" class="align-middle text-center table-header-item text-nowrap result-field-width" >Wynik</th> 
                                    <th scope="col" class="align-middle text-center table-header-item table-left-border-big text-nowrap" style="max-width: 40px;" >Pozycja</th> 
                                </tr>

                            </thead>

                            <tbody>
                            
                            <tr v-for="data, index in getEliminatorsData" v-bind:class="(isRowBigSeparator(index)) ? 'table-bottom-border-big' : ''"  >
                                <td class="align-middle text-center" style="max-width: 20px;" >{{ data.lane }}</td>
                                <td v-if="index % groupPlayersCount === 0" class="align-middle text-center fw-bold last-fill-border-2" style="font-size: 4rem; max-width: 30px;" :rowspan="groupPlayersCount" >{{ Math.floor(index / groupPlayersCount) + 1 }}</td>
                                <td class="align-middle text-center last-fill-border" >{{ data.name }}</td>
                                <td class="align-middle text-center fw-bold last-fill-border item-green bonus-field-width" >{{ data.hdcp1r }}</td>
                                <td class="align-middle text-center fw-bold last-fill-border item-green bonus-field-width" >{{ data.bonus }}</td>
                                <td class="align-middle text-center table-left-border-big game-field-width" >
                                    <div class="row" >
                                        <div class="col-12 d-flex align-self-center justify-content-center" >
                                            {{ data.results[0] }}
                                        </div>
                                    </div> 
                                </td>
                                <td class="align-middle text-center result-field-width" >{{ data.total_results[0] }}</td>
                                <td class="align-middle text-center table-left-border-big game-field-width" >
                                    <div class="row" >
                                        <div class="col-12 d-flex align-self-center justify-content-center" >
                                            {{ data.results[1] }}
                                        </div>
                                    </div>                                                 
                                </td>
                                <td class="align-middle text-center result-field-width" >{{ data.total_results[1] }}</td>
                                <template v-if="eliminatorRoundsCount === 3">
                                <td class="align-middle text-center table-left-border-big game-field-width" >
                                    <div class="row" >
                                        <div class="col-12 d-flex align-self-center justify-content-center" >
                                            {{ data.results[2] }}
                                        </div>
                                    </div> 
                                </td>
                                <td class="align-middle text-center result-field-width" >{{ data.total_results[2] }}</td>
                                </template>
                                <td class="align-middle text-center table-left-border-big game-field-width" >
                                    <div class="row" >
                                        <div class="col-12 d-flex align-self-center justify-content-center" >
                                            {{ data.results[eliminatorRoundsCount] }}
                                        </div>
                                    </div>
                                </td>
                                <td class="align-middle text-center result-field-width" >{{ data.total_results[eliminatorRoundsCount] }}</td>
                                <td class="align-middle text-center table-left-border-big" style="max-width: 40px;" >{{ data.position }}</td>
                            </tr>

                            </tbody>
                        </table>
                    </template>
                </template>
            </div>
        </div>
    </div>
</div>
</template>

<style scoped>
[v-cloak] {
    display: none;
}

th, td {
    font-weight: normal;
    max-height: 25px;
    padding-top: inherit;
    padding-bottom: inherit;
}

.text-justify {
    text-align: justify;
    text-justify: inter-word;
}
.text-justify:after {
    content: "";
    display: inline-block;
    width: 100%;
}

.table-list {
    padding-right: calc(var(--bs-gutter-x) * 0.5);
    padding-left: calc(var(--bs-gutter-x) * 0.5);
}

.table-list-header {
    border-radius: var(--bs-border-radius) var(--bs-border-radius) 0 0;
}

.table-list-header > .table-item:first-child {
    border-radius: var(--bs-border-radius) 0 0 0;
}

.table-list-header > .table-item:last-child {
    border-radius: 0 var(--bs-border-radius) 0 0;
}

.table-header-item {
    background-color: #F1F3F5 !important;
}

.table-item {
    /*border-style: solid;
    border-color: red;
    border-width: 1px 0 0 1px;*/
    border: 1px solid #C7C8CA;
    margin: -1px 0 0 -1px;
}

.table-border-fix {
    border-width: 1px 0 1px 1px;
}

.table-border {
    border: 1px solid #C7C8CA !important;
}

.table-left-border-big {
    border-left-width: 4px !important;
}

.table-bottom-border-big {
    border-bottom-width: 4px !important;
}


/*
tbody > tr:last-child > .last-fill-border {
    border-width: 0px !important;
    color: red;
}

tbody > tr:last-child > .last-fill-border-2 {
    border-width: 0px !important;
    color: red;
}

*/

.max-width-50 {
    max-width: 50px;
}

.border-bottom-line-big {
    border-color: #C7C8CA;
    border-style: solid;
    border-width: 0;
    border-bottom-width: 3px;
}

.item-green {
    color: var(--bs-form-valid-color) !important;
}

.eliminator-table-item {
    /*border-style: solid;
    border-color: red;
    border-width: 1px 0 0 1px;*/
    border: 1px solid #C7C8CA;
    margin: -1px 0 0 -1px;
    /* margin: -1px 0 0 -1px; */
}

.bonus-field-width {
    width: 60px;
    max-width: 60px;  
}

.result-field-width {
    width: 60px;
    max-width: 60px;  
}

.game-field-width {
    width: 70px;
    max-width: 70px;
}
</style>

<script>
export default {
    name: 'preview-eliminator-results-list',
    data: function() {
        return {}
    },
    props: {
        tournamentAllData: {
            type: Object,
            required: true,
        },
        appSettings: {
            type: Object,
            required: true,
        }, 
        isAfterLoadSetup: {
            type: Boolean,
            required: true,
        }                   
    },
    computed: {
        eliminatorRoundsCount: function() {
            return ((this.appSettings?.eliminatorPersonCount) && (this.appSettings.eliminatorPersonCount === 6)) ? 2 : 3;
        },  
        groupPlayersCount: function() {
            return ((this.appSettings?.eliminatorPersonCount) && (this.appSettings.eliminatorPersonCount === 6)) ? 3 : 4;
        },                  
        getEliminatorsData: function() {

            if (!this.isAfterLoadSetup) {
                return [];
            }            
  
            var i = 0;
            var j = 0;
            var k = 0;
            let data = [];


            for (i = 0; i < this.tournamentAllData.eliminators.length; i++ ) {
                let obj = new Object();
                obj.id = this.tournamentAllData.eliminators[i].id;
                obj.tournament_id = this.tournamentAllData.eliminators[i].tournament_id;
                obj.player_id = this.tournamentAllData.eliminators[i].player_id;
                obj.lane = this.tournamentAllData.eliminators[i].lane;
                obj.group = this.tournamentAllData.eliminators[i].group;
                obj.name = this.tournamentAllData.eliminators[i].player.name;
                obj.hdcp1r = this.tournamentAllData.eliminators[i].hdcp1r;
                obj.bonus = this.tournamentAllData.eliminators[i].bonus;
                obj.isAccepted = this.tournamentAllData.eliminators[i].isAccepted;
                obj.isCanceled = this.tournamentAllData.eliminators[i].isCanceled;
                obj.position = null;
                obj.enabled = true;
                if (this.eliminatorRoundsCount === 2) {
                    obj.resultenabled = [true, true, true];
                } else {
                    obj.resultenabled = [true, true, true, true];
                }
                obj.extra = this.tournamentAllData.eliminators[i].extra;
                obj.results = [];
                obj.total_results = [];
                obj.real_results = [];
                let result_val = 0;
                let total_val = 0;
                for (j = 0; j < this.tournamentAllData.eliminators[i].results.length; j++) {


                    let handicap_multiplier = 0;
                    let bonus_multiplier = 0;                            
                    switch (j) {
                        case 0: 
                            if (this.appSettings.handicapInFirstEliminatorGame > 0) {
                                handicap_multiplier = (this.appSettings.handicapInFirstEliminatorGame === 1) ? 0.5 : 1;
                            }
                            if (this.appSettings.bonusInFirstEliminatorGame > 0) {
                                bonus_multiplier = (this.appSettings.bonusInFirstEliminatorGame === 1) ? 0.5 : 1;
                            }
                            break;
                        case 1: 
                            if (this.appSettings.handicapInSecondEliminatorGame > 0) {
                                handicap_multiplier = (this.appSettings.handicapInSecondEliminatorGame === 1) ? 0.5 : 1;
                            }
                            if (this.appSettings.bonusInSecondEliminatorGame > 0) {
                                bonus_multiplier = (this.appSettings.bonusInSecondEliminatorGame === 1) ? 0.5 : 1;
                            }
                            break;
                        case 2: 
                            if (this.appSettings.handicapInThirdEliminatorGame > 0) {
                                handicap_multiplier = (this.appSettings.handicapInThirdEliminatorGame === 1) ? 0.5 : 1;
                            }
                            if (this.appSettings.bonusInThirdEliminatorGame > 0) {
                                bonus_multiplier = (this.appSettings.bonusInThirdEliminatorGame === 1) ? 0.5 : 1;
                            }
                            break;
                        case 3: 
                            if (this.appSettings.handicapInFourthEliminatorGame > 0) {
                                handicap_multiplier = (this.appSettings.handicapInFourthEliminatorGame === 1) ? 0.5 : 1;
                            }
                            if (this.appSettings.bonusInFourthEliminatorGame > 0) {
                                bonus_multiplier = (this.appSettings.bonusInFourthEliminatorGame === 1) ? 0.5 : 1;
                            }
                            break;                                                                                                       
                    }
                    //obj.hdcp1r = Math.ceil(obj.hdcp1r * handicap_multiplier);
                    //obj.bonus = Math.ceil(obj.bonus * bonus_multiplier); 
                            
                            
                    if (this.tournamentAllData.eliminators[i].results[j] !== null) {
                        if (this.tournamentAllData.confirmIncomingResults) {
                            if ((this.tournamentAllData.eliminators[i].isAccepted[j] === true) || (this.tournamentAllData.eliminators[i].isCanceled[j] === false))  {
                                result_val = this.tournamentAllData.eliminators[i].results[j];


                                total_val = result_val + Math.ceil(obj.hdcp1r * handicap_multiplier) + Math.ceil(obj.bonus * bonus_multiplier);
                                //total_val = result_val + obj.hdcp1r + obj.bonus;
                            } else {
                                result_val =  null;
                                total_val = null;
                            }
                        } else {
                            result_val = this.tournamentAllData.eliminators[i].results[j];
                            //total_val = result_val + obj.hdcp1r + obj.bonus;
                            total_val = result_val + Math.ceil(obj.hdcp1r * handicap_multiplier) + Math.ceil(obj.bonus * bonus_multiplier);
                        }
                    } else {
                        result_val =  null;
                        total_val = null;
                    }
                    obj.results.push(result_val);
                    obj.total_results.push(total_val);
                    obj.real_results.push(this.tournamentAllData.eliminators[i].results[j]);
                }
                data.push(obj);
            }

            //console.log(data);


            let index = 0;


            //czy runda sie zakończyła (czyli czy odpowiednia ilosć zawodników przesłała punkty)
            let counter = 0;
            for (i = 0; i < this.eliminatorRoundsCount + 1; i++) {
                for (j = 0; j < data.length; j++) {
                    if (data[j].results[i] === null) {
                        counter++;
                    }
                }
                if (counter > (i * 2)) {
                    break;
                }
                index++;  
                counter = 0;
            } 



            //wybierz najgoszego z 1 i drugiej grupy
            for (i = 0; i < index; i++) {
                let index1 = -1;
                let index2 = -1;
                let list1 = (this.groupPlayersCount === 3) ? data.slice(0, 3) : data.slice(0, 4);
                list1.sort(function(a, b) {
                    if (a.total_results[i] + a.extra[i] > b.total_results[i] + b.extra[i]) {
                        return -1;
                    } else if (a.total_results[i] + a.extra[i] < b.total_results[i] + b.extra[i]) {
                        return 1;
                    }
                    return 0;
                });
                for (j = list1.length - 1; j >= 0; j--) {
                    if (list1[j].enabled) {
                        index1 = j;
                        break;
                    }
                }
                list1[index1].enabled = false;
                let list2 = (this.groupPlayersCount === 3) ?  data.slice(3, 6) : data.slice(4, 8);
                list2.sort(function(a, b) {
                    if (a.total_results[i] + a.extra[i] > b.total_results[i] + b.extra[i]) {
                        return -1;
                    } else if (a.total_results[i] + a.extra[i] < b.total_results[i] + b.extra[i]) {
                        return 1;
                    }
                    return 0;
                });
                //console.log(list2);
                for (j = list2.length - 1; j >= 0; j--) {
                    if (list2[j].enabled) {
                        index2 = j;
                        break;
                    }
                }
                list2[index2].enabled = false;

                //przyznaj mu miejsce
                if (list1[index1].total_results[i] > list2[index2].total_results[i]) {
                    list1[index1].position = (this.groupPlayersCount * 2) - (i * 2) - 1;
                    list2[index2].position = (this.groupPlayersCount * 2) - (i * 2);
                } else {
                    list1[index1].position = (this.groupPlayersCount * 2) - (i * 2);
                    list2[index2].position = (this.groupPlayersCount * 2) - (i * 2) - 1;
                }

                //jeżeli przesłał punkty ktoś kto nie powinien ich przeslac to null
                for (j = 0; j < data.length; j++) {
                    for (k = i; k < data[j].results.length - 1; k++) {
                        if (data[j].enabled === false) {
                            data[j].resultenabled[k+1] = false;
                            data[j].results[k+1] = null;
                            data[j].total_results[k+1] = null;
                        }

                    }
                }

            }

            data.currentRound = index;

            //wszyskie punkty z rund które sie jeszcze nie odbyły na null
            for (let i = index + 1; i < this.eliminatorRoundsCount + 1; i++) {
                for (let j = 0; j < data.length; j++) {
                    data[j].results[i] = null;
                    data[j].total_results[i] = null;
                }
            }

            return data;
        }
    },
    methods: {
        isRowBigSeparator: function(index) {
            let divider = ((this.appSettings?.eliminatorPersonCount) && (this.appSettings.eliminatorPersonCount === 6)) ? 3 : 4;
            return (((index + 1) % divider === 0) && (index < this.getEliminatorsData.length - 1))
        }, 
    },
    mounted: function() {
        console.log('component preview-eliminator-results-list mounted')
    }
};      
</script>